import { InjectionToken } from '@angular/core';

export interface CoreWindowConfig {
  isWebview: boolean;
}

export const CORE_WINDOW_CONFIG = new InjectionToken<CoreWindowConfig>(
  'CORE_WINDOW_CONFIG',
  {
    providedIn: 'root',
    factory: () => ({ isWebview: false }),
  },
);
